// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserCell_avatar__bAqud","typographyParent":"UserCell_typographyParent__1vGiT"};